export default [
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `<p>Одностраничный <a href="/products/calendars">календарь плакат</a> А2 (420х594мм) с индивидуальным рисунком.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `<p>Цифровая печать</p>`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
